/**
 * widgets/Splash.ts · 启动屏隐藏
 *
 * 设计原则:
 *   - 唯一来源 · 不让多 IIFE 抢
 *   - hydrate 后立即隐藏 (避免闪烁)
 *   - 失败时 main.ts catch 保留 splash 显错误
 */

export function hideSplash(): void {
  const splash = document.getElementById('tn-boot-splash');
  if (!splash) return;
  splash.setAttribute('data-hydrated', '1');
  // 200ms 后真正 remove (让 CSS transition 完成)
  setTimeout(() => splash.remove(), 200);
}
